// THIS CODE WAS AUTO-GENERATED from '/packages/icon/icons/makeSvgsIntoJsx.js'
// PLEASE DO NOT EDIT HERE. EDIT THE FILE THAT MADE THIS
import React from 'react'
import { sanitizeProps } from '@fs/zion-frontend-friends'
import { ToggleIcon as BaseIcon, type IconProps } from '../BaseIcon'
import { rtlFlipCss, wipeOnCss, wipeOffCss } from '../iconStyles'

export default (props: IconProps): JSX.Element => (
  <BaseIcon {...sanitizeProps(props)}>
    <g className={rtlFlipCss}>
      <g className={wipeOnCss}>
        <path d="m22.31 3.2-7.27 7.26-.08 4.74-4.68.03-6.99 6.99-1.42-1.42L20.89 1.78z" />
        <path d="m22.31 3.2-7.27 7.26-.08 4.74-4.68.03-6.99 6.99-1.42-1.42L20.89 1.78z" />
      </g>
      <path d="M3.56 16.34A12 12 0 0 1 1 12.39a11.9 11.9 0 0 1 13.73-7.17L13 6.94a9.8 9.8 0 0 0-9.82 5.45A10 10 0 0 0 5 14.89zm10.75-4.91a2.51 2.51 0 1 1-4.57 2.07l-.15-.42-1.5 1.5a4.5 4.5 0 1 0 6.1-6.1l-1.5 1.5c.7.23 1.33.76 1.62 1.45m2.45-5.54-1.53 1.55a10 10 0 0 1 5.59 4.95 9.8 9.8 0 0 1-14.33 3.8L5.06 17.6A11.82 11.82 0 0 0 23 12.4a12 12 0 0 0-6.24-6.5" />
      <path
        d="m13 6.94 1.73-1.72q.84.2 1.65.5l.47.21-1.58 1.52A10 10 0 0 0 13 6.94m-8 7.95-1.44 1.45q.73.7 1.53 1.3l1.43-1.43q-.83-.59-1.52-1.32m4.5-2.5a2.5 2.5 0 0 1 2.46-2.5H12q.38 0 .73.11l1.5-1.5a4.47 4.47 0 0 0-6.12 6.11l1.49-1.49q-.1-.36-.1-.73"
        className={wipeOffCss}
      />
    </g>
  </BaseIcon>
)
